"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class FuseSearchBarModule {
}
exports.FuseSearchBarModule = FuseSearchBarModule;
